import React from "react";
import "../styles/CourseStudy.css";

interface Props {
  modules: any[];
  activeModuleId: string | number;
  onSelectModule: (moduleId: string | number) => void;
}

const ModuleNavigator: React.FC<Props> = ({
  modules,
  activeModuleId,
  onSelectModule,
}) => {
  return (
    <aside className="module-sidebar">
      <h3 className="sidebar-title">Course Modules</h3>

      {modules.map((module) => (
        <button
          key={module.id}
          className={`module-btn ${
            activeModuleId === module.id ? "active-module" : ""
          }`}
          onClick={() => onSelectModule(module.id)}
        >
          {module.title}
        </button>
      ))}
    </aside>
  );
};

export default ModuleNavigator;
